import {
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_FAILURE,
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST,
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_SUCCESS,
  DEPARTURE_MAILBOX_CHECKED,
  DEPARTURE_POSTAL_OPERATOR_EXPANDED,
  SELECT_ALL_DEPARTURE_MAILBOXES,
  DESELECT_ALL_DEPARTURE_MAILBOXES,
  DEPARTURE_POSTAL_OPERATOR_EXPANDED_MAILBOX_ADMIN,
} from './types/DeparturePostalOperatorActionTypes';

export function retrieveOutboundPostalOperatorsMailboxRequestActionCreator(
  payload,
  reportDefinition,
  departureCheckedMailboxes,
) {
  return {
    type: RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST,
    payload,
    reportDefinition,
    departureCheckedMailboxes,
  };
}

export function retrieveOutboundPostalOperatorsMailboxSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_SUCCESS,
    payload,
  };
}

export function retrieveOutboundPostalOperatorsMailboxFailureActionCreator(error) {
  return {
    type: RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_FAILURE,
    error,
  };
}

export function departureMailboxCheckedActionCreator(
  checkedMailboxes,
  reportDefinition,
) {
  return {
    type: DEPARTURE_MAILBOX_CHECKED,
    checkedMailboxes,
    reportDefinition,
  };
}

export function onDeparturePostalOperatorExpanded(expandedPostalOperators) {
  return {
    type: DEPARTURE_POSTAL_OPERATOR_EXPANDED,
    expandedPostalOperators,
  };
}

export function onDeparturePostalOperatorExpandedMailboxAdmin(expandedPostalOperatorsMailboxAdmin) {
  return {
    type: DEPARTURE_POSTAL_OPERATOR_EXPANDED_MAILBOX_ADMIN,
    expandedPostalOperatorsMailboxAdmin,
  };
}

export function onSelectAllDepartureMailboxes(nodes) {
  return {
    type: SELECT_ALL_DEPARTURE_MAILBOXES,
    payload: {
      nodes,
    },
  };
}

export function onDeSelectAllDepartureMailboxes() {
  return {
    type: DESELECT_ALL_DEPARTURE_MAILBOXES,
  };
}

